// CarouselIndicator.styles.ts
import styled from "@emotion/styled";
import { SvgWrapperProps } from "./CarouselIndicator.types";
import { getColor } from "../../theme/theme";

// Main container for the indicator
export const IndicatorContainer = styled.div<{
  width: number;
  height: number;
  color: string;
  isTransition: boolean;
  transitionSpeed: number;
}>`
  border-radius: 9999999px;
  box-shadow: ${({ color }) => `0 0 0 1px ${getColor(color)} inset`};
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};
  box-sizing: content-box;
  position: relative;
  overflow: hidden; /* Add overflow hidden to prevent children from overflowing */
  div {
    left: 0;
    position: absolute;
    box-sizing: content-box;
    box-shadow: ${({ color }) => `0 0 0 1px ${getColor(color)} inset`};
    border-radius: 9999999px;
    transition: ${({ isTransition = true, transitionSpeed = 0.3 }) =>
      isTransition ? `transform ${transitionSpeed}s ease` : "none"};
    height: 100%;
  }
  div:last-of-type {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

// Wrapper for the SVG (with rotation)
export const SvgWrapper = styled.span<SvgWrapperProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${({ percent = 0 }) => `rotate(${(percent / 100) * 360}deg)`};
  transition: ${({ isTransition = true, transitionSpeed = 0.3 }) =>
    isTransition ? `transform ${transitionSpeed}s ease` : "none"};
`;
export const StyledDiv = styled.div<{ width: string; transform: string }>`
  width: ${({ width }) => width};
  transform: ${({ transform }) => transform};
`;
